import {
  Component,
  ContentChildren,
  OnDestroy,
  QueryList,
  ViewChild,
  ElementRef,
  HostBinding,
} from '@angular/core';
import { merge, Observable, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

import { AutocompleteOptionComponent } from './autocomplete-option.component';
import {
  AutocompleteOptionClickEvent,
  AutocompleteOptionHoverEvent,
} from './autocomplete.model';

@Component({
  selector: 'nibtravel-autocomplete-handler',
  templateUrl: './autocomplete-handler.component.html',
  exportAs: 'autocompleteHandler',
})
export class AutocompleteHandlerComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  @HostBinding('class') klass = 'autocomplete-host';

  @HostBinding('class.autocomplete-hide') isHidden = true;

  @ViewChild('root')
  rootTemplate!: ElementRef<any>;

  @ContentChildren(AutocompleteOptionComponent)
  optionComponents = new QueryList<AutocompleteOptionComponent>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  optionsClick(): Observable<AutocompleteOptionClickEvent> {
    return this.optionComponents.changes.pipe(
      switchMap((changes: AutocompleteOptionComponent[]) => {
        const clicks$ = changes.map((change: AutocompleteOptionComponent) =>
          change.optionClicked.asObservable()
        );
        return merge(...clicks$);
      }),
      takeUntil(this.destroy$)
    );
  }

  optionsHover(): Observable<AutocompleteOptionHoverEvent> {
    return this.optionComponents.changes.pipe(
      switchMap((changes$: AutocompleteOptionComponent[]) => {
        const hovers$ = changes$.map((change: AutocompleteOptionComponent) =>
          change.optionHovered.asObservable()
        );
        return merge(...hovers$);
      }),
      takeUntil(this.destroy$)
    );
  }
}
